import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Mail, MapPin } from 'lucide-react';
import WhatsAppIcon from './WhatsAppIcon';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo and Description */}
        <div className="footer-column">
          <img 
            src="https://customer-assets.emergentagent.com/job_15838cb8-d5c8-4088-b574-f4de08159ff9/artifacts/rfx6tebm_Copie%20de%20Copie%20de%20Madeira%20outdoors-5.png" 
            alt="Madeira Outdoors" 
            className="footer-logo"
          />
          <p className="footer-description">{t('footer.tagline')}</p>
          <div className="footer-social">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <Instagram size={20} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <Youtube size={20} />
            </a>
            <a href="https://tripadvisor.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 0 0 4.04 10.43 5.976 5.976 0 0 0 4.246-1.746l1.757-1.755 1.757 1.755a5.98 5.98 0 0 0 4.245 1.746 5.997 5.997 0 0 0 4.037-10.43L24 6.648h-4.361c-2.307-1.569-4.974-2.353-7.633-2.353zm-6 7.711a3.998 3.998 0 1 1 7.996 0 3.998 3.998 0 0 1-7.996 0zm6 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm5.998-3.997a3.998 3.998 0 1 1 0 7.996 3.998 3.998 0 0 1 0-7.996zm0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h3 className="footer-title">{t('footer.quickLinks')}</h3>
          <ul className="footer-links">
            <li><Link to="/">{t('nav.home')}</Link></li>
            <li><Link to="/experiences">{t('nav.packages')}</Link></li>
            <li><Link to="/services">{t('nav.dailyTours')}</Link></li>
            <li><Link to="/about">{t('nav.about')}</Link></li>
            <li><Link to="/mission">{t('nav.mission')}</Link></li>
            <li><Link to="/blog">{t('nav.blog')}</Link></li>
            <li><Link to="/contact">{t('nav.contact')}</Link></li>
            <li><Link to="/partners" data-testid="footer-partners-link">{t('footer.partners')}</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div className="footer-column">
          <h3 className="footer-title">{t('footer.legal')}</h3>
          <ul className="footer-links">
            <li><Link to="/privacy">{t('footer.privacy')}</Link></li>
            <li><Link to="/terms">{t('footer.terms')}</Link></li>
            <li><Link to="/cookies">{t('footer.cookies')}</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-column">
          <h3 className="footer-title">{t('footer.contact')}</h3>
          <ul className="footer-contact">
            <li>
              <MapPin size={18} />
              <span>Funchal, Madeira Island, Portugal</span>
            </li>
            <li>
              <Mail size={18} />
              <span>bookings@madeiraoutdoors.com</span>
            </li>
            <li>
              <a
                href="https://wa.me/351968656613"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-link"
              >
                <WhatsAppIcon size={18} />
                <span>WhatsApp · +351 968 656 613</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Madeira Outdoors. {t('footer.rights')}.</p>
      </div>
    </footer>
  );
};

export default Footer;
